module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[16]381.ebd3a30.woff2";